<template>
  <div class="popup">
    <h4 class="popup__title middle">Список {{ getName() }}</h4>

    <div class="popup-list">
      <span v-if="typeSvoyClubInfo === 'firms'" v-for="firm of svoyClubFirms">{{ firm.kod }} - {{ firm.name }}</span>

      <span v-if="typeSvoyClubInfo === 'tobsl'" v-for="tobsl of svoyClubTobls">{{ tobsl.kod }} - {{ tobsl.name }}</span>

      <span v-if="typeSvoyClubInfo === 'regions'" v-for="region of svoyClubToblsRegions">{{ region.name }}</span>
    </div>

    <div class="actions">
      <button class="button btn-primary" @click="closeAll()">Закрыть</button>
    </div>
  </div>
</template>

<script>

import {popups} from '@/mixins/popups'
import {mapState} from "vuex";
export default {
  name: "svoyClubInfoPopup",
  mixins: [popups],
  data: () => ({}),
  computed: {
    ...mapState({
      svoyClubFirms: state => state.admin.svoyClubFirms,
      svoyClubTobls: state => state.admin.svoyClubTobls,
      svoyClubToblsRegions: state => state.admin.svoyClubToblsRegions,
      typeSvoyClubInfo: state => state.popups.typeSvoyClubInfo,
    })
  },
  methods: {
    getName() {
      if (this.typeSvoyClubInfo === 'firms') {
        return 'компаний'
      }
      if (this.typeSvoyClubInfo === 'tobsl') {
        return 'точек'
      }
      if (this.typeSvoyClubInfo === 'regions') {
        return 'регионов'
      }
    }
  },
  mounted() {}
}
</script>

<style scoped lang="scss">
@import "../../styles/variables";

.popup {
  :deep(.loader) {
    height: 200%;
    width: 200%;
    left: -50%;
    top: -50%;
    border-radius: 25px;
    transform: scale(0.5);
    svg {
      position: unset;
    }
  }
}

.popup-list {
  display: flex;
  flex-direction: column;
  overflow: auto;
}

span {
  margin-bottom: 10px;
  padding-bottom: 5px;
  text-align: left;
  border-bottom: 1px solid rgba(26, 26, 24, 0.1);
}

.actions {
  margin-top: 15px;
}
</style>
